<template>
	<sa-page-layout :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
		<template slot="toolbar">
			<div style="float: right">
				<b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" @click="onClickSave">
					<b-icon icon="check2"></b-icon>
					Salva
				</b-button>
				<b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickSaveClose">
					<b-icon icon="check2"></b-icon>
					Salva e Chiudi
				</b-button>
				<b-button variant="secondary btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickIndietro">
					<b-icon icon="chevron-left"></b-icon>
					Indietro
				</b-button>
				<b-button v-if="tab == 0" variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickAssociaProfili">
					<b-icon icon="people-fill"></b-icon>
					Associa Profili
				</b-button>

				<b-button v-if="tab == 1" variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickPreview">
					<i class="far fa-file-pdf"></i>
					Preview
				</b-button>
				<b-button v-if="tab == 2" variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickFormattaJson">
					<i class="fas fa-align-left"></i>
					Formatta
				</b-button>
				<b-button v-if="tab == 2" variant="info btn-toolbar float-sm-right sa-margin-right" size="sm"
					@click="onClickSetTags">
					<i class="far fa-file-pdf"></i>
					Carica Tags
				</b-button>
			</div>
		</template>
		<template slot="table-header"> </template>
		<template slot="table-body">
			<consensi-edit-component ref="cmpConsensiEditComponent" @inputTab="onInputTab"></consensi-edit-component>
			<ConsensiProfiliListModalComponent ref="mdlConsensiProfiliListModalComponent" />
		</template>
		<template slot="table-footer"></template>

	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConsensiEditComponent from "../components/ConsensiEditComponent.vue";
import ConsensiProfiliListModalComponent from "../components/ConsensiProfiliListModalComponent.vue";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	components: { SaPageLayout, ConsensiEditComponent, ConsensiProfiliListModalComponent },
	data() {
		return {
			showModalLoading: false,
			btnNewVisible: true,
			tab: 0,
			btnRefreshVisible: true,
			pathResource: "/consensi",
			struttureOptions: [],
			content: "ciao",
			id: null,
			linkback: "/consensi",
			jsonData: {},
			filtro: {
				nomeConsenso: null,
				codiceStruttura: null,
				sezione: null,
				tipologia: null,
			},
			linkedit: "",
		};
	},
	mounted() { },
	methods: {
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
		onClickSaveClose() {
			this.$refs.cmpConsensiEditComponent.saveResource(true);
		},
		onClickSave() {
			this.$refs.cmpConsensiEditComponent.saveResource(false);
		},
		onInputTab(tab) {
			this.tab = tab;
			if (tab == 2) {
				this.$refs.cmpConsensiEditComponent.onClickFormattaJson();
				this.$refs.cmpConsensiEditComponent.onClickSetTags();
			}
		},
		onClickIndietro() {
			this.$router.back();
		},
		onClickFormattaJson() {
			this.$refs.cmpConsensiEditComponent.onClickFormattaJson();
		},
		onClickSetTags() {
			this.$refs.cmpConsensiEditComponent.onClickSetTags();
		},
		onClickPreview() {
			this.$refs.cmpConsensiEditComponent.onClickPreview();
		},
		onClickAssociaProfili() {
			let consenso = this.$refs.cmpConsensiEditComponent.getConsenso();
			this.$refs.mdlConsensiProfiliListModalComponent.init(consenso);
		},

	},
};
</script>

<style></style>
